import { LiquidationAgreement } from 'features/SubmitProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { Can } from 'components/Can';

function EditLiquidationAgreementPage() {
  return (
    <LayoutProvider>
      <Layout>
        <Can do="update" on="liquidation">
          <LiquidationAgreement />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}

export default EditLiquidationAgreementPage;
